/**
 * Rollout flag for the Agent Map V2 overhaul (auto-layout, all-agents view,
 * search/filters, skill badges — see AgentMapPageV2).
 *
 * CRA inlines `process.env.REACT_APP_*` values at build time, so this is a
 * build-time switch, not a runtime one. Default is ON: only the literal
 * string 'false' disables it, so an unset or misconfigured env var still
 * ships the new experience rather than silently falling back to legacy.
 *
 * @returns {boolean} true when Agent Map V2 should render.
 */
export function isAgentMapV2Enabled() {
  return process.env.REACT_APP_AGENT_MAP_V2 !== 'false';
}
